




























import {
  CreateCustomerAccount,
  CreateReseller
} from '@/router';

import AccountsTable from '@/components/tables/AccountsTable.vue'
import CustomersTable from '@/components/tables/CustomersTable.vue'
import TabbedCard from '@/components/cards/TabbedCard.vue'
import {Store} from '@/store/store'
import FinancialSnapshots from '@/components/cards/FinancialSnapshots.vue'
import Component from 'vue-class-component'

@Component({
  components: {
    CreateCustomerAccount,
    CreateReseller,
    AccountsTable,
    CustomersTable,
    FinancialSnapshots,
    TabbedCard,
  },
  metaInfo: {
    title: 'Dashboard'
  }
})
export default class Home extends Store {
  componentTitle = 'Distributor Dashboard';
  createCustomerRoute = CreateCustomerAccount;
  createResellerRoute = CreateReseller;

  tabs: Array<any> = [
    {
      id: 'resellers',
      title: 'Resellers',
    },
    {
      id: 'customers',
      title: 'Customers',
    },
  ]
}
